import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';
import {
  AUTHORIZE_PATH,
  CHANGE_PASSWORD_PATH,
  LOGIN_PATH,
  LOGIN_REDIRECT_PATH,
  LOGOUT_PATH,
} from './authPaths';

/**
 * These are paths that are related to authentication like login, logout, change password, etc.
 */
export const AUTH_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'Login',
    },
    isPrivateRoute: false,
    path: LOGIN_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/Login')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'LoginRedirect',
    },
    isPrivateRoute: false,
    path: LOGIN_REDIRECT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/LoginRedirect')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // This is intentionally not tracked because it is a logout page
    },
    isPrivateRoute: false,
    path: LOGOUT_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../components/Logout')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'ChangePassword',
    },
    isPrivateRoute: true,
    path: CHANGE_PASSWORD_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/ChangePassword')
    ).Component,
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'AuthorizePage',
    },
    isPrivateRoute: true,
    path: AUTHORIZE_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/AuthorizePage')
    ).Component,
  },
];
